import React from 'react';
import SelectLabelComponent from "./select-label-component";
import {connect} from "react-redux";
import {selectLabelColor, toggleLabelSelection} from "./select-label-action-creators";


const SelectLabelContainer = props => {
  return <SelectLabelComponent {...props} />
};


const mapStateToProps = state => ({
  selectedLabelColor: state.selectLabel.selectedLabelColor,
  labelSelectionIsShown: state.selectLabel.labelSelectionIsShown
});


const mapDispatchToProps = dispatch => ({
  toggleLabelSelection: () => dispatch(toggleLabelSelection()),
  selectLabelColor: color => dispatch(selectLabelColor(color))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectLabelContainer)


// WEBPACK FOOTER //
// ./src/modules/select-label/select-label-container.js